import Common from '../Common';

class Provider extends Common {
  constructor() {
    super('/api/v1/settings/payment-cards', true);
    this.saveToken = this.saveToken.bind(this);
  }

  saveToken(token) {
    return this.save({ token }, '/token');
  }
}

const provider = new Provider();

export const { get, save, saveToken, remove } = provider;



// WEBPACK FOOTER //
// ./src/services/providers/settings/payment_card.js